import type { AdElement } from '@adflow/types';

import type { CanvasDocumentState } from './documentModel';

export function applyDocumentLayoutToAdElements(
  elements: AdElement[],
  document: CanvasDocumentState,
): AdElement[] {
  const layoutById = new Map(document.elements.map((entry) => [entry.id, entry]));
  return elements.map((element) => {
    const layout = layoutById.get(element.id);
    if (!layout) {
      return element;
    }
    return {
      ...element,
      position: {
        ...element.position,
        x: layout.x,
        y: layout.y,
        z: layout.z,
      },
    };
  });
}

export function paintOrderIds(elements: readonly AdElement[]): string[] {
  return [...elements]
    .filter((element) => element.type !== 'SVG')
    .sort((a, b) => (a.position?.z ?? 0) - (b.position?.z ?? 0))
    .map((element) => element.id);
}

/** Shared Preview/prototype check: z-ordered ids match before layout edits. */
export function assertSharedResolvedPaintOrderParity(
  inputElements: readonly AdElement[],
  resolvedElements: readonly AdElement[],
): boolean {
  return paintOrderIds(inputElements).join('|') === paintOrderIds(resolvedElements).join('|');
}
